import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_flow_order_data_rnno_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { order_id: number, op_code: number }): Promise<{ result?: { outputData?: { headerData?: { warehouseName?: string, contactFirstName?: string, addressLine1?: string, addressLine2?: string, addressAttentionOf?: string, addressCityStateZip?: string, projectLookupCode?: string, accountLookupCode?: string, accountName?: string, orderLookupCode?: string, vendorReference?: string, loadContainerId?: string, carrierName?: string, carrierShortName?: string, sealId?: string, driverName?: string, vehicleLicense?: string, tempReadings?: string, orderRequestedDeliveryDate?: string, dockAppointementLookupCode?: string }, bodyData?: { taskId?: number, materialLookupCode?: string, materialDescription?: string, vendorLotExpirationDate?: string, lotLookupCode?: string, vendorLotLookupCode?: string, sourceLicensePlate?: string, targetLicensePlate?: string, operationCodeName?: string, actualInventoryAmount?: number, actualPackagedAmount?: number, grossWeight?: number, netWeight?: number, weightUOM?: string, warehouseName?: string, taskCount?: number, packagedShortName?: string, packagedName?: string }[], summaryData?: { totalPackagedAmount?: number, totalGrossWeight?: number, totalNetWeight?: number, palletAmountPerClass?: string, dateString?: string }, materialData?: { materialId?: number, materialLookupCode?: string, materialDescription?: string, totalInventoryAmount?: number, totalPackagedAmount?: number, totalGrossWeight?: number, totalNetWeight?: number, weightUOM?: string, packagedName?: string, packagedShortName?: string }[], dateString?: string } } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.op_code)) {
      $missingRequiredInParams.push('\'op_code\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      order_id: number, op_code: number    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
        if(isNil($inParams.op_code)) {
          return true; 
        }
      return false;
    }
}
